<ng-container *ngIf="entries.length > 0; else noContactInformation">

    <div class="body">

        <div *ngIf="headline" class="headline">
            {{headline}}
        </div>
    
        <div class="content">
    
            <ng-container *ngFor="let entry of entries">
    
                <div class="row">
        
                    <ng-container *ngIf="entry.icon; else iconPlaceholder">
        
                        <mat-icon>{{entry.icon}}</mat-icon>
        
                    </ng-container>
        
                    <div class="text-wrapper">
        
                        <div class="value">
                            {{entry.value}}
                        </div>
        
                        <div class="type">
                            {{entry.type}}
                        </div>
        
                    </div>
        
                </div>
        
            </ng-container>
    
        </div>
    
    </div>
    
    <ng-template #iconPlaceholder>
    
        <div class="icon-placeholder"></div>
    
    </ng-template>

</ng-container>

<ng-template #noContactInformation>

    <div class="no-contact-information-hint">

        Keine Kontaktinformationen bekannt

    </div>

</ng-template>